import { StrictMode, type ComponentType } from "react";
import { createRoot } from "react-dom/client";

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("Elemento #raiz não encontrado no index.html");

// A LOJA ONLINE (/loja, ou um domínio que comece com "loja.") carrega só o código dela: o
// cliente nunca baixa o scanner/OCR nem o CSS do sistema interno, e vice-versa.
let ehLoja = /^\/loja(\/|$)/.test(window.location.pathname) || window.location.hostname.startsWith("loja.");

/**
 * Quem abre o endereço principal (/) sem estar logado cai direto na LOJA: visitante não precisa ver
 * a tela de usuário e senha. O dono entra pelo /entrar (link "Área do lojista" no rodapé da loja).
 * Logado, o / continua abrindo o sistema de estoque como sempre.
 */
async function decidirRaiz() {
  if (ehLoja || window.location.pathname !== "/") return;
  try {
    const eu = await fetch("/api/auth/eu", { credentials: "same-origin" }).then((r) => r.json());
    if (!eu.autenticado && !eu.primeiroAcesso) {
      window.history.replaceState(null, "", "/loja");
      ehLoja = true;
    }
  } catch {
    // sem resposta: mantém o comportamento antigo (tela de login)
  }
}

/**
 * O service worker existe para a LOJA poder ser instalada como app e abrir rapido
 * na segunda visita. Ele nao entra no sistema interno (scanner/estoque) e nunca
 * toca em /api: preco, estoque e carrinho vem sempre da rede. Ver public/sw.js.
 */
function registrarServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") return;
  navigator.serviceWorker.register("/sw.js").catch(() => {
    // sem service worker a loja funciona igual; so nao instala como app
  });
}

async function iniciar() {
  let Tela: ComponentType;
  await decidirRaiz();
  if (ehLoja) window.addEventListener("load", registrarServiceWorker);
  if (ehLoja) {
    if (window.location.hostname.startsWith("loja.") && !window.location.pathname.startsWith("/loja")) {
      window.history.replaceState(null, "", "/loja" + window.location.pathname.replace(/^\/$/, ""));
    }
    await import("./globals.css");
    await import("./loja/loja.css");
    Tela = (await import("./loja/Loja")).default;
  } else {
    // Em sequência de propósito: a ordem dos CSS define a cascata (igual aos imports de antes).
    await import("./globals.css");
    await import("./catalog.css");
    await import("./catalog-actions.css");
    await import("./catalog-remove.css");
    await import("./stock-actions.css");
    await import("./novos-estilos.css");
    Tela = (await import("./App")).default;
  }
  createRoot(raiz!).render(
    <StrictMode>
      <Tela />
    </StrictMode>
  );
}

iniciar();
